<template>
  <BFormGroup
    :label="translatedText(data.name) + (data.mandatory ? ' *' : '')"
    :label-for="`multiselect-input-${data.key}`"
    :state="validation"
  >
    <BFormCheckboxGroup
        :id="`multiselect-input-${data.key}`"
        :required="data.mandatory"
        :model-value="modelValue"
        :options="options"
        :state="validation"
        stacked
        @update:model-value="$emit('update:modelValue', $event)"
    />
  </BFormGroup>
</template>

<script setup>
import {computed} from "vue";
import {translate} from "@/domain/utils/translations";
import {BFormGroup} from "bootstrap-vue-next";
import {inputStatus} from "@/domain/pform/validations";
import {buildOptions} from "@/domain/pform/sortOptions";


defineEmits(['update:modelValue'])
const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  lang: {
    type: String,
    required: true
  },
  modelValue: {
    type: Array,
    required: true
  },
  isSubmitted: {
    type: Boolean,
    default: false
  }
})

const options = computed(() => buildOptions(props.data.params, props.lang))

const validation = computed(() => inputStatus(props.data.type, props.data.mandatory, props.modelValue, props.isSubmitted))

const translatedText = (field) => translate(field, props.lang)
</script>